import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutUs from "./pages/about-us";
import Home from "./pages/home";
import OurTeam from "./pages/our-team";
import Values from "./pages/values";
import Blogs from "./pages/Blogs";
import EchoChambers from "./pages/Blogs/echoChambers";
import MisogynyOnline from "./pages/Blogs/MisogynyOnline";
import SubscriptionModel from "./pages/Blogs/SubscriptionModel";
import Trolling from "./pages/Blogs/Trolling";
import Origin from "./pages/origin";
import News from "./pages/News";
import Incubation from "./pages/News/incubation";
import Imprintborn from "./pages/News/imprintBorn";
import Imprintpartners from "./pages/News/imprintpartners";
import Imprintmodsquad from "./pages/News/imprintmodsquad";
import Imprintcheck from "./pages/News/checkstep";
import Imprintsocial from "./pages/News/imprintsocial";
import Imprintcollege from "./pages/News/imprintCollege";
import Imprintmindful from "./pages/News/imprintMindful";
import Imprintbbfc from "./pages/News/imprintbbfc";
import Imprintbooks from "./pages/News/imprintbooks";
import Imprintusers from "./pages/News/imprintusers";
import Imprintroundtable from "./pages/News/imprintroundtable";
import Imprintcharities from "./pages/News/imprintcharities";
import Imprintyoti from "./pages/News/imprintyoti";
import Imprintwellbeing from "./pages/News/imprintwellbeing";
import TermsConditions from "./pages/terms-and-conditions";
import Eula from "./pages/eula";
import AcceptancePolicy from "./pages/acceptable-use-policy";
import CommunityGuidelines from "./pages/community-guidelines";
import PrivacyPolicy from "./pages/privacy-policy";
import CookiesPolicy from "./pages/cookies-policy";
import OnlineSafetyPolicy from "./pages/online-safety-policy";
import NextOfKinPolicy from "./pages/next-of-kin-policy";
import Disclaimer from "./pages/disclaimer";
import ImprintAudit from "./pages/News/ImprintAudit";
import ImprintDamechionwurah from "./pages/News/imprintDamechionwurah";
import ImprintJeremywright from "./pages/News/imprintJeremywright";
import ImprintMaxwilkinson from "./pages/News/imprintMaxwilkinson";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/values" element={<Values />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route
          path="/blogs/echo-chambers-decline-diversity"
          element={<EchoChambers />}
        />
        <Route path="/blogs/misogyny-Online" element={<MisogynyOnline />} />
        <Route path="/newss/misogyny-Online" element={<MisogynyOnline />} />
        <Route
          path="/blogs/suscription-model"
          element={<SubscriptionModel />}
        />
        <Route path="/blogs/trolling" element={<Trolling />} />
        <Route path="/origin" element={<Origin />} />
        <Route path="/news" element={<News />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/eula" element={<Eula />} />
        <Route path="/acceptable-use-policy" element={<AcceptancePolicy />} />
        <Route path="/community-guidelines" element={<CommunityGuidelines />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="/online-safety-policy" element={<OnlineSafetyPolicy />} />
        <Route path="/next-of-kin-policy" element={<NextOfKinPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/news/incubation" element={<Incubation />} />
        <Route path="/news/imprint-born" element={<Imprintborn />} />
        <Route path="/news/imprint-partners" element={<Imprintpartners />} />
        <Route path="/news/imprint-modsquad" element={<Imprintmodsquad />} />
        <Route path="/news/imprint-checkstep" element={<Imprintcheck />} />
        <Route path="/news/imprint-social" element={<Imprintsocial />} />
        <Route path="/news/imprint-college" element={<Imprintcollege />} />
        <Route path="/news/imprint-mindful" element={<Imprintmindful />} />
        <Route path="/news/imprint-bbfc" element={<Imprintbbfc />} />
        <Route path="/news/imprint-books" element={<Imprintbooks />} />
        <Route path="/news/imprint-users" element={<Imprintusers />} />
        <Route
          path="/news/imprint-roundtable"
          element={<Imprintroundtable />}
        />
        <Route path="/news/imprint-charities" element={<Imprintcharities />} />
        <Route path="/news/imprint-yoti" element={<Imprintyoti />} />
        <Route path="/news/imprint-wellbeing" element={<Imprintwellbeing />} />
        <Route path="/news/imprint-audit" element={<ImprintAudit />} />
        <Route
          path="/news/imprint-damechionwurah"
          element={<ImprintDamechionwurah />}
        />
        <Route
          path="/news/imprint-jeremywright"
          element={<ImprintJeremywright />}
        />
        <Route
          path="/news/imprint-maxwilkinson"
          element={<ImprintMaxwilkinson />}
        />
      </Routes>
    </Router>
  );
};

export default App;
